import React from 'react'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import chatUtils from '../../shared/util/chatUtils'
import cls from './index.scss'
const cx = _cx.bind(cls)

//
// NOTE: The name is slightly misleading, since this isn't actually a link in it's current form. It wasn't changed
// because this has been exported in the public interface for a long while now. It never used a href, or any other
// attributes specific to an anchor tag anyway.
//
const ChatLink = ({ user = {}, chatText = 'Live Chat', isButton }) => {
  const openChatPopup = () => {
    chatUtils.openChatPopup(user)
  }

  return (
    <div className={cx('chat-link-wrapper')}>
      <span
        data-elm-id='chat-link'
        className={cx('link', isButton && 'button')}
        onClick={openChatPopup}
      >
        {chatText}
      </span>
    </div>
  )
}

ChatLink.propTypes = {
  user: PropTypes.object,
  chatText: PropTypes.string,
  isButton: PropTypes.bool,
}

export default ChatLink
